"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "prignano-sulla-secchia": {
    "16a5ad74": [{
      "hkey": "fd3b3374",
      "slug": "morano-serra",
      "name": "Morano-Serra",
      "primary": true,
      "skipSearch": false
    }],
    "morano": [{
      "hkey": "fd3b3374",
      "slug": "morano-serra",
      "name": "Morano-Serra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prignano-sulla-secchia"
    }],
    "08584ecc": [{
      "hkey": "7a406404",
      "slug": "volta-di-pigneto",
      "name": "Volta di Pigneto",
      "primary": true,
      "skipSearch": false
    }],
    "pigneto": [{
      "hkey": "7a406404",
      "slug": "volta-di-pigneto",
      "name": "Volta di Pigneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "75dcd2ad": [{
      "hkey": "fd3b3374",
      "slug": "morano-serra",
      "name": "Morano-Serra",
      "primary": true,
      "skipSearch": false
    }],
    "serra": [{
      "hkey": "fd3b3374",
      "slug": "morano-serra",
      "name": "Morano-Serra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "59825ac5": [{
      "hkey": "39dc662f",
      "slug": "prignano-sulla-secchia",
      "name": "Prignano sulla Secchia",
      "primary": true,
      "skipSearch": false
    }],
    "volta-di-saltino": [{
      "hkey": "39dc662f",
      "slug": "prignano-sulla-secchia",
      "name": "Prignano sulla Secchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;